export const ApplicationSortingOptions = [
  "Last Closed",
  "Last Opened",
  "Last Submission",
  "Last Updated",
  "Organization",
  "Title",
];